module.exports = __webpack_public_path__ + "components/home-header/static/header-5--huge@2x-e3a7d0d07c5dad3703d92be84be5890d.jpg";